export enum DocumentsDeleteActionTypes {
  OPEN_DOCUMENTS_DELETION_DIALOG = 'OPEN_DOCUMENTS_DELETION_DIALOG',
  CLOSE_DOCUMENTS_DELETION_DIALOG = 'CLOSE_DOCUMENTS_DELETION_DIALOG',
  DELETE_FILDERS = 'DELETE_FILDERS'
}
